import api from "../../api.js";

export async function fetchPatientOtcScripts(patientId) {
  const res = await api.get(`/api/otc/patients/${encodeURIComponent(patientId)}/scripts`);
  return res.data?.data || [];
}

export async function fetchNextOtcNumber() {
  const res = await api.get(`/api/otc/next-number`);
  return res.data?.data?.otcNumber || null;
}
